import { render, staticRenderFns } from "./addBook.vue?vue&type=template&id=39b925f8&scoped=true&"
import script from "./addBook.vue?vue&type=script&lang=js&"
export * from "./addBook.vue?vue&type=script&lang=js&"
import style0 from "./addBook.vue?vue&type=style&index=0&id=39b925f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b925f8",
  null
  
)

export default component.exports